import { AllUserRoles, UserRole } from 'src/auth/types';

export const AdminAndMethodologist = [UserRole.ADMIN, UserRole.METHODOLOGIST]; // on the roles description page - these combined into one column

export const AdminGroup = [UserRole.SYSTEM_ADMIN, ...AdminAndMethodologist, UserRole.SECRETARIAT];

export const AdminAndSecretariat = [UserRole.SYSTEM_ADMIN, UserRole.SECRETARIAT];

export const AdminNoSecretariatGroup = [UserRole.SYSTEM_ADMIN, ...AdminAndMethodologist];

export const SpecialTeachersGroup = [
    UserRole.SPEECH_THERAPIST,
    UserRole.INTELLECTUAL_DISABILITY_TEACHER,
    UserRole.DEAF_TEACHER,
    UserRole.VISION_TEACHER,
    UserRole.TEACHER_PPP
];

export const TeachersGroup = [
    UserRole.PRESCHOOL_TEACHER,
    UserRole.ASSISTANT_PRESCHOOL_TEACHER,
    UserRole.JUNIORS_TEACHER,
    UserRole.ASSISTANT_JUNIORS_TEACHER,
    UserRole.TEACHER,
    UserRole.FOREIGN_LANGUAGE_TEACHER,
    UserRole.SPECIAL_EDUCATION_TEACHER
];

export const EducationalPlanBaseRoleGroup = [
    UserRole.SYSTEM_ADMIN,
    UserRole.SECRETARIAT,
    UserRole.METHODOLOGIST,
    UserRole.ADMIN,
    UserRole.PSYCHOLOGIST,
    UserRole.SPECIAL_EDUCATION_TEACHER
];

export const PreSchoolRoles = [UserRole.PRESCHOOL_TEACHER];

export const PreSchoolAndBaseRoles = [...PreSchoolRoles, ...EducationalPlanBaseRoleGroup];

export const JuniorSchoolRoles = [UserRole.JUNIORS_TEACHER, UserRole.FOREIGN_LANGUAGE_TEACHER];

export const JuniorSchoolAndBaseRoles = [...JuniorSchoolRoles, ...EducationalPlanBaseRoleGroup];

export const HighSchoolRoles = [UserRole.TEACHER, UserRole.FOREIGN_LANGUAGE_TEACHER];

export const HighSchoolAndBaseRoles = [...HighSchoolRoles, ...EducationalPlanBaseRoleGroup];

export const ScheduleAvailableRoles = [...AdminGroup, UserRole.PSYCHOLOGIST, ...TeachersGroup, ...SpecialTeachersGroup];

export const AllExceptParentsRolesGroup: UserRole[] = AllUserRoles.filter(
    (value: UserRole) => value !== UserRole.PARENT
);

export const AllExceptAdminAndMethodologist: UserRole[] = AllUserRoles.filter(
    (value: UserRole) => !AdminAndMethodologist.includes(value)
);

export const AllExceptAdminGroup: UserRole[] = AllUserRoles.filter((value: UserRole) => !AdminGroup.includes(value));

export const SystemAdminAndSecretaryRolesGroup: UserRole[] = [UserRole.SYSTEM_ADMIN, UserRole.SECRETARIAT];
